import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '..//Button';
import CrossIcon from '../Icons/CrossIcon';
import * as S from './styled';

const DeleteConfirmPopover = ({
  onDeleteConfirm,
  shouldShowBorder,
  preferPlace,
  place,
  title,
}) => {
  const [isPopoverOpen, setPopoverOpen] = useState(false);

  return (
    <S.DeleteConfirmPopover
      style={{
        maxHeight: '90px',
      }}
      isOpen={isPopoverOpen}
      preferPlace={preferPlace}
      place={place}
      onOuterAction={() => {
        setPopoverOpen(false);
      }}
      body={
        <S.DeleteConfirmWrapper shouldShowBorder={shouldShowBorder}>
          <S.DeleteConfirmTitle>{title}</S.DeleteConfirmTitle>
          <S.DeleteConfirmButtonsWrapper>
            <S.DeleteButton
              onClick={() => {
                setPopoverOpen(false);
                onDeleteConfirm();
              }}
            >
              Delete
            </S.DeleteButton>
            <S.CancelButton
              onClick={() => {
                setPopoverOpen(false);
              }}
            >
              Cancel
            </S.CancelButton>
          </S.DeleteConfirmButtonsWrapper>
        </S.DeleteConfirmWrapper>
      }
    >
      <Button
        appearance="subtle-link"
        spacing="none"
        onClick={() => {
          setPopoverOpen(true);
        }}
        withIcon
      >
        <CrossIcon size="middle" />
      </Button>
    </S.DeleteConfirmPopover>
  );
};

DeleteConfirmPopover.propTypes = {
  onDeleteConfirm: PropTypes.func,
  place: PropTypes.string,
  preferPlace: PropTypes.string,
  title: PropTypes.string,
  shouldShowBorder: PropTypes.bool,
};

DeleteConfirmPopover.defaultProps = {
  onDeleteConfirm: () => {},
  shouldShowBorder: false,
  preferPlace: 'left',
  place: 'left',
  title: 'Are you sure you want to delete this worklog?',
};

export default DeleteConfirmPopover;
